module.exports = __webpack_public_path__ + "img/table_two.18b6b1b3.svg";